var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-dialog',{staticClass:"blocker-dialog",attrs:{"is-show":_vm.show,"md-props":{
    mdClickOutsideToClose: false,
    mdCloseOnEsc: false,
    mdFullscreen: false,
  }}},[_c('div',{staticClass:"lc-dialog-container-1 lc-padding-bottom-24"},[_c('h1',{staticClass:"lc-font-size-32 lc-margin-bottom-8"},[_vm._v("\n      "+_vm._s(_vm.$t('Dialog.blocker.title'))+"\n    ")]),_vm._v(" "),_c('p',{staticClass:"lc-font-size-16 lc-color-like-gray-4"},[_vm._v("\n      "+_vm._s(_vm.$t('Dialog.blocker.content'))+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }